(() => {
  if (customElements.get('stock-location-check')) return;

  const ENDPOINT = 'https://plain-rain-9b1d.julia-huber.workers.dev/stock';
  const queue = new Map();
  let timer = null;

  function flush() {
    const batch = new Map(queue);
    queue.clear();
    timer = null;
    fetch(`${ENDPOINT}?ids=${[...batch.keys()].join(',')}`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}))
      .then((data) => batch.forEach((els, id) => els.forEach((el) => el.apply(data[id]))));
  }

  class StockLocationCheck extends HTMLElement {
    connectedCallback() {
      const id = this.dataset.variantId;
      if (!id) return this.setAttribute('checked', '');
      if (!queue.has(id)) queue.set(id, []);
      queue.get(id).push(this);
      if (!timer) timer = setTimeout(flush, 50);
      // Fallback: nach 2 s Standardanzeige zeigen, falls Worker nicht antwortet
      setTimeout(() => this.setAttribute('checked', ''), 2000);
    }

    apply(stock) {
      if (stock) {
        const leipzig = Number(stock.leipzig) || 0;
        const cogito = Number(stock.cogito) || 0;
        const low = Number(this.dataset.thresholdLow) || 5;
        const veryLow = Number(this.dataset.thresholdVeryLow) || 2;
        const compact = !!this.querySelector('template[data-state="ready"]');

        let state = null;
        if (leipzig > 0) {
          state = compact ? 'ready' : leipzig <= veryLow ? 'very_low' : leipzig <= low ? 'low' : 'in_stock';
        } else if (cogito > 0) {
          state = 'cogito';
        } else if (compact) {
          // Bestand in anderem Lager (z. B. Gumatech) → versandfertig
          state = 'ready';
        }

        const tpl = state && this.querySelector(`template[data-state="${state}"]`);
        const target = this.querySelector('[data-default]');
        if (tpl && target) {
          target.innerHTML = tpl.innerHTML.replaceAll('__QTY__', String(leipzig));
        }
      }
      this.setAttribute('checked', '');
    }
  }

  customElements.define('stock-location-check', StockLocationCheck);
})();